import { useEffect, useState } from 'react';

export const useInputEvent = () => {
  const [key, setKey] = useState(null);
  useEffect(() => {
    const keyDownHandler = ({ code }) => setKey(code);
    const keyUpHandler = () => setKey(null);
    global.addEventListener('keydown', keyDownHandler);
    global.addEventListener('keyup', keyUpHandler);
    return () => {
      global.removeEventListener('keydown', keyDownHandler);
      global.removeEventListener('keyup', keyUpHandler);
    };
  }, []);
  return key;
};

const konamiCode = [
  'ArrowUp',
  'ArrowUp',
  'ArrowDown',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'ArrowLeft',
  'ArrowRight',
  'KeyB',
  'KeyA'
];

export const useKonamiCode = () => {
  const [count, setCount] = useState(0);
  const [success, setSuccess] = useState(false);
  const key = useInputEvent();

  useEffect(() => {
    const isActive = localStorage.getItem('isKonamiCodeActive');
    if (isActive) {
      setSuccess(true);
      return;
    }
  }, []);

  useEffect(() => {
    if (key == null) return;
    if (key !== konamiCode[count]) {
      setCount(0);
      return;
    }

    setCount(state => state + 1);
    if (count + 1 === konamiCode.length) {
      const newState = !success;
      setSuccess(newState);
      if (newState) {
        localStorage.setItem('isKonamiCodeActive', '1');
      } else {
        localStorage.removeItem('isKonamiCodeActive');
      }
    }
  }, [key]);

  return success;
};
